import React, { Component } from 'react'
import {NavLink} from 'react-router'
import './List.css'
import API from '../API'
import ListEntry from './ListEntry'
import AddIcon from '../Icons/Add.svg'

class WebList extends Component {
	constructor(props) {
		super(props)
		this.state = {}
		this.Refresh()
	}
	async Refresh() {
		this.setState({WebForwards: (await API("Web/List"))?.sort((a,b)=>{
			if (a.Hostname < b.Hostname)
				return -1
			if (a.Hostname > b.Hostname)
				return 1
			return 0
		})})
	}
	render() {
		const List = []
		const Named = {}
		for (let x in this.state.WebForwards||[]) {
			Named[this.state.WebForwards[x].Hostname.toLocaleLowerCase()] = this.state.WebForwards[x]
		}
		for (let Hostname in Named) {
				if (this.state.Filter?.length && Hostname.indexOf(this.state.Filter.toLocaleLowerCase()) == -1)
				continue
			List.push(<ListEntry app={this.props.app} data={Named[Hostname]} />)
		}
		if (this.state.WebForwards) {
			return (
				<div className="WebList">
					<div class="Row">
						<NavLink to="/ui/web/_"><img style={{height:'2.2em'}}className="Icon" src={AddIcon} /></NavLink>
						<input value={this.state.Filter} className={this.state.Filter?'Changed Right':' Right'} onInput={e=>this.setState({Filter:e.target.value})} />
					</div>
					<h1>Web Forwards</h1>
					{List}
				</div>
			)
		} else {
			return (<div className="WebList Loading">Loading...</div>)
		}
	}
}

export default WebList

